// import React, { useState } from "react";
// import { Button, Modal, Form, Input } from "antd";
// import { NewSaveLeadForSales } from "../request/apiRquest";

// // ab yaha direct server ka brochure link download hoga
// const downloadPDF = (brochureUrl) => {
//   const link = document.createElement("a");
//   link.href = brochureUrl;
//   link.download = brochureUrl.split("/").pop(); // filename set karne ke liye
//   link.click();
// };

// const BrochureDownload = ({ download_link }) => {
//   const [open, setOpen] = useState(false);
//   const [form] = Form.useForm();

//   const showModal = () => setOpen(true);
//   const closeModal = () => setOpen(false);
//   const handleCancel = () => setOpen(false);

//  const handleOk = () => {
//   try {
//     form.validateFields()
//       .then((values) => {
//         const payload = {
//           contactNo: values.contactNumber || "",
//           email: values.email || "",
//           expectedRevenue: values.expectedRevenue || 0,
//           firstName: values.firstName || "",
//           pipelineName: values.pipelineName || "Trinestsky Website Leads",
//           leadSource: values.leadSource || "trinestsky.com",
//           leadType: values.leadType || "Sales",
//           pipelineStageId: values.pipelineStageId || 0,
//           priority: values.priority || "medium",
//           productId: values.productId || 26,
//           remark: values.description || "",
//         };

//         // Save API call
//         NewSaveLeadForSales(payload);


//         // Trigger actual brochure PDF download after saving
//         if(download_link){          
//           downloadPDF(download_link);
//         }

//         // Close modal + reset form
//         setOpen(false)
//         form.resetFields();
//       })
//       .catch((info) => {
//         console.log("Validate Failed:", info);
//       })
//   } catch (error) {
//     console.error("Unexpected error:", error);
//   }
// };


//   return (
//     <>
//       <Button
//         type="primary"
//         onClick={showModal}
//         style={{
//           backgroundColor: "#fda94f",
//           color: "#fff",
//           borderColor: "#fda94f",
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.backgroundColor = "#fff";
//           e.currentTarget.style.color = "#fda94f";
//           e.currentTarget.style.borderColor = "#fda94f";
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.backgroundColor = "#fda94f";
//           e.currentTarget.style.color = "#fff";
//           e.currentTarget.style.borderColor = "#fda94f";
//         }}
//       >
//         Download Brochure
//       </Button>

//       <Modal
//         title="Download Brochure"
//         open={open}
//         onOk={handleOk}
//         onCancel={handleCancel}
//         okText="Submit & Download"
//         okButtonProps={{
//           style: {
//             backgroundColor: "#fda94f",
//             borderColor: "#fda94f",
//             color: "#fff",
//           },
//         }}
//       >
//         <Form
//           form={form}
//           layout="vertical"
//           name="brochureForm"
//           initialValues={{
//             firstName: "",
//             // lastName: "",
//             email: "",
//             contactNumber: "",
//             description: "",
//           }}
//         >

//           <Form.Item
//             label="Full Name"
//             name="firstName"
//             rules={[
//               { required: true, message: "Please enter your Name!" },
//               {
//                 validator: (_, value) => {
//                   if (!value) {
//                     return Promise.resolve(); // required rule will handle empty
//                   }
//                   if (/\s/.test(value.trim())) {
//                     return Promise.resolve();
//                   }
//                   return Promise.reject(
//                     new Error("Please enter your full name ")
//                   );
//                 },
//               },
//             ]}
//           >
//             <Input />
//           </Form.Item>



//           {/* <Form.Item
//             label=" Name"
//             name="firstName"
//             rules={[{ required: true, message: "Please enter your  Name!" }]}
//           >
//             <Input />
//           </Form.Item> */}

//           {/* <Form.Item
//             label="Last Name"
//             name="lastName"
//             rules={[{ required: true, message: "Please enter your Last Name!" }]}
//           >
//             <Input />
//           </Form.Item> */}

//           {/* <Form.Item
//             label="Email"
//             name="email"
//             rules={[
//               { required: true, message: "Please enter your Email!" },
//               { type: "email", message: "Please enter a valid Email!" },
//             ]}
//           >
//             <Input />
//           </Form.Item> */}
//           <Form.Item
//             label="Email"
//             name="email"
//             rules={[
//               { required: true, message: "Please enter your Email!" },
//               { type: "email", message: "Please enter a valid Email!" },
//             ]}
//           >
//             <Input
//               onChange={(e) => {
//                 const lowercaseValue = e.target.value.toLowerCase();
//                 // update form field with lowercase value
//                 form.setFieldsValue({ email: lowercaseValue });
//               }}
//             />
//           </Form.Item>


//           <Form.Item
//             label="Contact Number"
//             name="contactNumber"
//             rules={[{ required: true, message: "Please enter your Contact Number!" }]}
//           >
//             <Input />
//           </Form.Item>

//           <Form.Item
//             label="Description"
//             name="description"
//             rules={[{ required: true, message: "Please enter your Description!" }]}
//           >
//             <Input />
//           </Form.Item>
//         </Form>
//       </Modal>
//     </>
//   );
// };

// export default BrochureDownload;


import React, { useState } from "react";
import { Button, Modal, Form, Input, notification } from "antd";
import { NewSaveLeadForSales } from "../request/apiRquest";

// Custom download with notification
const downloadPDF = async (brochureUrl) => {
  try {
    // notification.info({
    //   message: "Download Started",
    //   description: "Your brochure download is starting...",
    //   placement: "topRight",
    // });

    const response = await fetch(brochureUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = brochureUrl.split("/").pop(); // filename
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    notification.success({
      message: "Download Complete",
      description: "Your brochure has been downloaded successfully.",
      placement: "bottomLeft",
    });
  } catch (error) {
    notification.error({
      message: "Download Failed",
      description: "There was an issue downloading the brochure.",
      placement: "topRight",
    });
  }
};

const BrochureDownload = ({ download_link }) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => setOpen(true);
  const closeModal = () => setOpen(false);
  const handleCancel = () => setOpen(false);

  const handleOk = () => {
    try {
      form
        .validateFields()
        .then((values) => {
          const payload = {
            contactNo: values.contactNumber || "",
            email: values.email || "",
            expectedRevenue: values.expectedRevenue || 0,
            firstName: values.firstName || "",
            pipelineName: values.pipelineName || "Trinestsky Website Leads",
            leadSource: values.leadSource || "trinestsky.com",
            leadType: values.leadType || "Sales",
            pipelineStageId: values.pipelineStageId || 0,
            priority: values.priority || "medium",
            productId: values.productId || 31,
            remark: values.description || "",
          };

          // Save API call
          NewSaveLeadForSales(payload);

          // Trigger actual brochure PDF download after saving
          if (download_link) {
            downloadPDF(download_link);
          }

          // Close modal + reset form
          setOpen(false);
          form.resetFields();
        })
        .catch((info) => {
          console.log("Validate Failed:", info);
        });
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  return (
    <>
      <Button
        type="primary"
        onClick={showModal}
        style={{
          backgroundColor: "#fda94f",
          color: "#fff",
          borderColor: "#fda94f",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#fff";
          e.currentTarget.style.color = "#fda94f";
          e.currentTarget.style.borderColor = "#fda94f";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#fda94f";
          e.currentTarget.style.color = "#fff";
          e.currentTarget.style.borderColor = "#fda94f";
        }}
      >
       Download Broucher
      </Button>

      <Modal
        title="Download Brochure"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit & Download"
        okButtonProps={{
          style: {
            backgroundColor: "#fda94f",
            borderColor: "#fda94f",
            color: "#fff",
          },
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="brochureForm"
          initialValues={{
            firstName: "",
            email: "",
            contactNumber: "",
            description: "",
          }}
        >
          <Form.Item
            label="Full Name"
            name="firstName"
            rules={[
              { required: true, message: "Please enter your Name!" },
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve(); // required rule will handle empty
                  }
                  if (/\s/.test(value.trim())) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Please enter your full name ")
                  );
                },
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your Email!" },
              { type: "email", message: "Please enter a valid Email!" },
            ]}
          >
            <Input
              onChange={(e) => {
                const lowercaseValue = e.target.value.toLowerCase();
                form.setFieldsValue({ email: lowercaseValue });
              }}
            />
          </Form.Item>

          <Form.Item
            label="Contact Number"
            name="contactNumber"
            rules={[
              { required: true, message: "Please enter your Contact Number!" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: "Please enter your Description!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default BrochureDownload;

